import React, { useState, useEffect, useContext } from "react";
import Expedientes from "../../Expedientes/Expedientes";
import Swal from "sweetalert2";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import {
  Grid,
  ButtonGroup,
  Button,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Fade,
  Typography,
  Box,
  Paper,
} from "@mui/material";
import {
  CommonSubHeader,
  normalizeText,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";
import {
  Topic,
  Star,
  ExpandMore,
  Edit,
  TableChart,
  MoveDownOutlined,
} from "@mui/icons-material";
import ObservationsCards from "../../Components/ObservationsCards";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";
import api from "../../api/axios";
import {
  arrayToStatus,
  notesHistoricLogic,
  nuevoArrayDeNotas,
} from "../../Components/helpers/ContactPlusClient/ContactNClientsHelpers";
import DuplicatedAlertList from "../../Components/helpers/ContactPlusClient/DuplicatedAlertList";
import ContactClientNotesComparisonDialog from "../../Components/ContactClientNotesComparisonDialog";
import Unauthorized from "../../Components/Common/Design/Unauthorized";
import {
  PermissionContext,
  UserContext,
} from "../../Components/Context/Context";
import { Link } from "lucide-react";

const Ver = () => {
  const navigate = useNavigate();
  const { goPanel, goTable, goEdit, goTransfer } = useLocationHelpers();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("id");
  const { can } = useContext(PermissionContext);
  const { userData } = useContext(UserContext);
  const { user, isSuperAdmin } = userData;

  const hasPermission = can("clients", "view");

  // State
  const [clientData, setClientData] = useState({});
  const [clientObservations, setClientObservations] = useState("");
  const [lawyerData, setLawyerData] = useState({});

  const [multipleContacts, setMultipleContacts] = useState([]);
  const [multipleClients, setMultipleClients] = useState([]);

  const [flagVip, setFlagVip] = useState(false);
  const [flag, setFlag] = useState(false);
  const [flagContactFounded, setFlagContactFounded] = useState(null);
  const [flagToReload, setFlagToReload] = useState(false);
  const [flagClientNoExistence, setFlagClientNoExistence] = useState(false);

  const [statuses, setStatuses] = useState(arrayToStatus);
  const [flagActiveCases, setFlagActiveCases] = useState(true);
  const [caseControlNumber, setCaseControlNumber] = useState(-1);

  // Helper para condiciones y valores por defecto
  const setDefault = (value, fallback = "Sin Asignar") =>
    value && value !== "null" && value.trim() ? value.trim() : fallback;

  const [differentNotes, setDifferentNotes] = useState([]);
  const [flagSameDocument, setFlagSameDocument] = useState(false);

  // GET DATA
  const getClient = async () => {
    setFlag(false);
    try {
      const url = `${process.env.REACT_APP_API_URL}/users/show`;
      const { data } = await api.post(url, { id: clientId });
      const {
        client,
        observations_contact = [],
        multiple_contacts = [],
        multiple_clients = [],
      } = data;

      console.log(data);

      multiple_clients?.length === 0 && !client
        ? setFlagClientNoExistence(true)
        : setFlagClientNoExistence(false);

      setMultipleContacts(
        Array.isArray(multiple_contacts) && multiple_contacts.length > 1
          ? multiple_contacts
          : [],
      );
      setMultipleClients(
        Array.isArray(multiple_clients) && multiple_clients.length > 0
          ? multiple_clients
          : [],
      );

      // Destructuración segura
      const {
        id = 0,
        name = "",
        surname = "",
        email = "",
        address = "",
        province = "",
        postalcode = "",
        nif = "",
        phone = "",
        notas = "",
        marketing = 0,
        lawyers_relation = {},
        company_relation = {},
        offices_relation = {},
        asociations_relation = {},
        document_types_relation,
        date_in = "",
        condiciones = "",
        company_id = 0,
      } = client || {};

      // Condiciones y VIP
      const processedConditions =
        typeof condiciones === "string"
          ? condiciones.replaceAll("<br />", "\n")
          : "";

      setFlagVip(processedConditions.toLowerCase().includes("vip"));

      const transformedNotes = nuevoArrayDeNotas(observations_contact) || {
        conClave: [],
        sinClave: [],
      };

      const resultadoFinal = [
        ...(Array.isArray(transformedNotes.conClave)
          ? transformedNotes.conClave
          : []),
        ...(Array.isArray(transformedNotes.sinClave)
          ? transformedNotes.sinClave
          : []),
      ];

      // Estado principal del cliente
      setClientData((prev) => ({
        ...prev,
        id: id,
        company_id: company_id,
        email: setDefault(email),
        name: setDefault(name),
        surname: setDefault(surname),
        address: setDefault(address),
        province: setDefault(province),
        postalcode: setDefault(postalcode),
        document: setDefault(nif),
        document_type: setDefault(document_types_relation?.name),
        phone: setDefault(phone),
        condiciones: processedConditions,
        marketing: marketing
          ? "Recibe notificaciones"
          : "No recibe notificaciones",
        cards: resultadoFinal.length > 0 ? resultadoFinal : [],
      }));

      setLawyerData({
        name:
          `${lawyers_relation?.name || ""} ${
            lawyers_relation?.surname || ""
          }`.trim() || "Sin Asignar",
        company: setDefault(company_relation?.company_name),
        office: setDefault(offices_relation?.office_name),
        asociation: setDefault(asociations_relation?.asoc_name),
      });

      setStatuses(arrayToStatus);

      ////////////////////////////// HANDLING //////////////////////////////
      var cleaner = false;

      cleaner = await notesHistoricLogic(
        multiple_contacts?.length == 1 ? multiple_contacts[0] : null,
        client,
        setDifferentNotes,
      );

      console.log(multiple_contacts);

      if (
        multiple_contacts.length === 1 &&
        multiple_contacts[0]?.id &&
        company_relation?.id == multiple_contacts[0]?.company_id
      ) {
        const contact = multiple_contacts[0];
        const flagContact = client?.nif == contact?.nif;
        setFlagContactFounded(contact);
        setFlagSameDocument(flagContact);
      }

      if (cleaner) setFlagToReload((prev) => !prev);
      ////////////////////////////// HANDLING //////////////////////////////
    } catch (error) {
      setFlagClientNoExistence(true);
      console.error("Error fetching client data:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo obtener la información del cliente.",
      });
    } finally {
      setFlag(true);
    }
  };

  useEffect(() => {
    if (!hasPermission) {
      return;
    }
    getClient();
  }, [clientId, flagToReload]);

  useEffect(() => {
    // console.log(caseControlNumber);
    if (caseControlNumber === 0) {
      setFlagActiveCases(false);
    } else {
      setFlagActiveCases(true);
    }
  }, [caseControlNumber]);

  const handleFormCreateCase = async () => {
    Swal.fire({
      title: "¿Desea crear un nuevo expediente?",
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
      confirmButtonText: "Continuar",
      denyButtonText: `Volver`,
    }).then((result) => {
      if (result.isConfirmed) {
        navigate(`/expedientes/crear?id=${clientId}`);
      }
    });
  };

  const handleDeleteClient = async () => {
    try {
      /* ================= CONFIRMACIÓN ================= */
      const { isConfirmed } = await Swal.fire({
        title: "¿Desea eliminar el cliente?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
        confirmButtonText: "Continuar",
        denyButtonText: "Volver",
      });

      if (!isConfirmed) return;

      /* ================= CARGA ================= */
      Swal.fire({
        title: "Eliminando cliente",
        text: "Por favor espere...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
        timerProgressBar: true,
      });

      /* ================= REQUEST ================= */
      const url = `${process.env.REACT_APP_API_URL}/users/destroy`;
      const { data } = await api.post(url, { id: clientId });

      /* ================= ÉXITO ================= */
      Swal.fire({
        icon: "success",
        title: "Cliente eliminado",
        text: data?.message ?? "El cliente fue eliminado correctamente",
        confirmButtonColor: "#1ab394",
      });

      navigate("/contactos");
    } catch (error) {
      /* ================= ERROR ================= */
      Swal.close();

      const message =
        error?.response?.data?.message ||
        "Ocurrió un error al eliminar el cliente";

      Swal.fire({
        icon: "error",
        title: "Error",
        text: message,
        confirmButtonColor: "#d33",
      });
    }
  };

  // Datos de cliente principales
  const clientInfo = [
    {
      label: "Nombre",
      value: `${clientData?.name || "--"} ${clientData?.surname || " "}`,
    },
    {
      label: "Documento",
      value: `${clientData?.document_type || "--"} / ${clientData?.document || "--"}`,
    },
    { label: "Dirección", value: `${clientData?.address || "--"}` },
    { label: "Provincia", value: `${clientData?.province || "--"}` },
    { label: "Código postal", value: `${clientData?.postalcode || "--"}` },
    { label: "Teléfono", value: `${clientData?.phone || "--"}` },
    { label: "Email", value: `${clientData?.email || "--"}` },
  ];

  const companyInfo = [
    {
      label: lawyerData?.company == 11 ? "Procurador" : "Abogado",
      value: `${lawyerData?.name || "--"}`,
    },
    {
      label: "Empresa",
      value: lawyerData?.company ? `${lawyerData?.company}` : "--",
    },
    {
      label: "Asociación",
      value: lawyerData?.asociation ? `${lawyerData?.asociation}` : "--",
    },
  ];

  if (!hasPermission) {
    return <Unauthorized />;
  }

  if (!flag) {
    return <LoadingPage isLoading={!flag} heightProp="600px" />;
  }

  if (flagClientNoExistence) {
    return (
      <Grid container item xs={12}>
        <Grid item xs={12}>
          <Alert severity="error">El cliente no existe...</Alert>
        </Grid>
      </Grid>
    );
  }

  const uniqueRelation =
    flagSameDocument &&
    flagContactFounded?.id &&
    flagContactFounded?.company_id == clientData?.company_id;

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Clientes" subTitle="Ver" />

      {hasPermission && (
        <Fade timeout={600} in>
          <Grid container className="fontSize">
            {uniqueRelation && (
              <Grid item xs={12} style={{ marginBottom: "10px" }}>
                <Alert severity="info" className="alertStyles">
                  <span>
                    Se ha encontrado un contacto asociado a este cliente, click
                    si desea verlo:
                  </span>
                  <Button
                    component={NavLink}
                    to={`/contactos/ver?id=${flagContactFounded?.id}`}
                    size="small"
                    color="info"
                    variant="outlined"
                    sx={{ marginLeft: "20px" }}>
                    Ver Contacto
                  </Button>
                </Alert>
              </Grid>
            )}

            <Grid container spacing={1} sx={{ padding: "8px" }}>
              {multipleContacts?.length > 1 && (
                <DuplicatedAlertList
                  items={multipleContacts}
                  entityName="contacto"
                  createNoteButton={true}
                />
              )}
              {multipleClients.length > 0 && (
                <DuplicatedAlertList
                  items={multipleClients}
                  entityName="cliente"
                />
              )}
            </Grid>

            {/* CONTENEDOR PRINCIPAL */}
            <Grid container>
              {/* PANEL IZQUIERDO – DATOS CLIENTE */}
              <Grid item xl={5} lg={5} md={5} xs={12} p={1}>
                <Paper
                  sx={{
                    p: 2,
                    borderRadius: "6px",
                    boxShadow: "0px 0px 25px -6px #1800b926",
                  }}>
                  {/* ===== DATOS CLIENTE ===== */}
                  <Divider sx={{ mb: 1 }} />
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    textAlign="center">
                    DATOS CLIENTE
                  </Typography>
                  <Divider sx={{ mt: 1, mb: 2 }} />

                  {clientInfo.map((info) => (
                    <Grid container spacing={1} key={info.label}>
                      <Grid item xs={4}>
                        <Typography fontWeight="bold" className="fontSize">
                          {info.label}:
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography
                          className="fontSize wordsOverflow"
                          sx={{ color: "#676a6c" }}>
                          {info.value}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}

                  {/* ===== DATOS EMPRESA ===== */}
                  <Divider sx={{ my: 2 }} />
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    textAlign="center">
                    DATOS EMPRESA
                  </Typography>
                  <Divider sx={{ mt: 1, mb: 2 }} />

                  {companyInfo.map((info) => (
                    <Grid container spacing={1} key={info.label}>
                      <Grid item xs={4}>
                        <Typography fontWeight="bold" className="fontSize">
                          {info.label}:
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography
                          className="fontSize wordsOverflow"
                          sx={{ color: "#676a6c" }}>
                          {info.value}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}

                  {/* ===== ACCIONES ===== */}
                  <Box mt="auto">
                    <Divider sx={{ my: 1 }} />
                    <Box display="flex" minHeight="40px">
                      <Fade
                        in={caseControlNumber !== null}
                        timeout={800}
                        sx={{ width: "100%" }}>
                        <Box>
                          <Box
                            sx={{
                              justifyContent: "flex-end",
                            }}>
                            {caseControlNumber === 0 &&
                              can("clients", "delete") && (
                                <Button
                                  color="error"
                                  variant="outlined"
                                  size="small"
                                  onClick={handleDeleteClient}>
                                  Eliminar cliente
                                </Button>
                              )}
                          </Box>

                          {caseControlNumber > 0 && (
                            <Alert severity="warning" width="100%">
                              Para eliminar este usuario, primero debe eliminar
                              sus expedientes asociados.
                            </Alert>
                          )}
                        </Box>
                      </Fade>
                    </Box>
                  </Box>
                </Paper>
              </Grid>

              {/* PANEL DERECHO – NOTAS */}
              <Grid item xl={7} lg={7} md={7} xs={12} p={1}>
                <Paper
                  sx={{
                    p: 2,
                    borderRadius: "6px",
                    boxShadow: "0px 0px 25px -6px #1800b926",
                    overflow: "hidden",
                  }}>
                  <Divider sx={{ mb: 1 }} />
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    textAlign="center">
                    NOTAS
                  </Typography>
                  <Divider sx={{ mt: 1, mb: 2 }} />

                  {/* ===== CONDICIONES ===== */}
                  {clientData?.condiciones === "" ? (
                    <Alert severity="warning">Sin condiciones asignadas.</Alert>
                  ) : (
                    <>
                      <Typography fontWeight="bold" mb={1}>
                        CONDICIONES
                      </Typography>
                      <Alert severity="warning">
                        <Box display="flex" alignItems="center">
                          {flagVip && <Star sx={{ mr: 1 }} />}
                          {clientData?.condiciones?.toUpperCase() || ""}
                        </Box>
                      </Alert>
                    </>
                  )}

                  <>
                    <Divider sx={{ my: 2 }} />
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 600, mb: 1 }}>
                      OBSERVACIONES
                    </Typography>

                    {/* ===== OBSERVACIONES ===== */}
                    <Box mt={2} sx={{ height: "300px", overflow: "auto" }}>
                      {clientObservations === "" &&
                      !clientData?.cards?.length > 0 ? (
                        <Alert severity="warning">
                          Sin observaciones asignadas.
                        </Alert>
                      ) : (
                        <>
                          {differentNotes?.length > 0 && (
                            <Alert severity="warning" sx={{ mb: 1 }}>
                              El cliente y el contacto tienen notas diferentes.
                              <ContactClientNotesComparisonDialog
                                notas={differentNotes}
                                client={clientData || []}
                                contact={flagContactFounded || []}
                                setFlagToReload={setFlagToReload}
                                flagToReload={flagToReload}
                              />
                            </Alert>
                          )}

                          {Array.isArray(clientData?.cards) &&
                            clientData.cards.map((obs, index) => {
                              const statusName =
                                statuses.find((s) => s.id === obs.status)
                                  ?.nombre || "Desconocido";

                              return (
                                <ObservationsCards
                                  key={index}
                                  observationId={obs?.id}
                                  company={obs?.company_relation?.company_name}
                                  created_by_name={
                                    obs?.created_by_relation?.name || "Primera"
                                  }
                                  created_by_surname={
                                    obs?.created_by_relation?.surname || "Nota"
                                  }
                                  date={obs?.created_at || "Indefinido"}
                                  title={obs?.title || "Sin título"}
                                  content={obs?.notas || ""}
                                  caseType={obs.types_relation?.case_type}
                                  status_name={statusName}
                                  created_by_object={obs?.created_by_relation}
                                />
                              );
                            })}
                        </>
                      )}
                    </Box>
                  </>
                </Paper>
              </Grid>

              {/* BOTONES */}

              {/* BOTONES */}
              <Grid item xs={12} p={1}>
                <ButtonGroup fullWidth sx={{ background: "white" }}>
                  {can("cases", "add") && (
                    <Button
                      onClick={handleFormCreateCase}
                      color="info"
                      variant="contained"
                      size="small"
                      startIcon={<Topic />}
                      sx={{ fontWeight: 700 }}>
                      Crear Expediente
                    </Button>
                  )}

                  {can("clients", "edit") && (
                    <Button
                      onClick={() => goEdit("clientes", clientId, "Cliente")}
                      variant="outlined"
                      color="success"
                      startIcon={<Edit />}
                      size="small">
                      Editar cliente
                    </Button>
                  )}

                  {isSuperAdmin && can("clients", "delete") && (
                    <Button
                      onClick={() => goTransfer("expedientes", clientId)}
                      variant="outlined"
                      color="secondary"
                      startIcon={<MoveDownOutlined />}
                      size="small">
                      Transferir Expedientes
                    </Button>
                  )}

                  {can("clients", "view") && (
                    <Button
                      onClick={() => goTable("clientes", "Clientes")}
                      variant="outlined"
                      color="error"
                      size="small"
                      startIcon={<TableChart />}>
                      Tabla
                    </Button>
                  )}
                </ButtonGroup>
              </Grid>
            </Grid>

            {can("cases", "view") && (
              <Grid item xs={12} sx={{ width: "100vw", padding: "8px" }}>
                <Accordion defaultExpanded sx={{ width: "100%" }}>
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header">
                    Expedientes
                  </AccordionSummary>
                  <AccordionDetails>
                    {flagActiveCases === true ? (
                      <Expedientes
                        flagToShow={false}
                        clientCase={clientData}
                        setCaseControlNumber={setCaseControlNumber}
                      />
                    ) : (
                      <Alert color="info" severity="info">
                        Sin expedientes asociados...
                      </Alert>
                    )}
                  </AccordionDetails>
                </Accordion>
              </Grid>
            )}
          </Grid>
        </Fade>
      )}
    </div>
  );
};

export default Ver;
